export default __webpack_public_path__ + "static/media/settle-3.f6ce021b.png";